// Constants file.

export const DELIMITERS = ['${', '}']
export const DURATION = .333

// Google api key.
export const GOOGLE_API_KEY = 'AIzaSyBBtJ_RNvPvOGQ7cGD7scOZZkPMYDtnXUs'



// WEBPACK FOOTER //
// ./assets/js/constants.js